"use client";

import { motion } from "motion/react";
import { useTranslations } from "next-intl";
import {
    Box,
    Stack,
    Typography,
    useTheme,
} from "@/components/controls/base-controls";

import {
    WEBPAGE_CORE_CONTAINER,
} from "@/core/constants/webpages";

const ServicesBanner = () => {
    const theme = useTheme();
    const t = useTranslations();

    return (
        <Box
            sx={{
                position: "relative",
                "&::after": {
                    content: '""',
                    position: "absolute",
                    inset: 0,
                    backgroundColor: "rgba(0, 0, 0, 0.45)",
                    zIndex: 0,
                },
                ...theme.mixins.bgImage({
                    xs: { src: "https://general-images.navairra.com/pj_over_caribbean_400x400.png", height: "320px" },
                    sm: { src: "https://general-images.navairra.com/pj_over_caribbean_900x400.png", height: "320px" },
                    md: { src: "https://general-images.navairra.com/pj_over_caribbean_1200x400.png", height: "400px" },
                    lg: { src: "https://general-images.navairra.com/pj_over_caribbean_1920x500.png", height: "400px" },
                    xl: { src: "https://general-images.navairra.com/pj_over_caribbean_2538x500.png", height: "400px" },
                    backgroundPosition: "center center",
                }),
            }}
        >
            <Stack
                component={motion.div} 
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.2 }}
                direction="column"
                sx={{
                    position: "relative",
                    zIndex: 1,
                    height: {
                        xs: "320px",
                        lg: "400px"
                    },
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "flex-start",
                    margin: "0 auto",
                    padding: "0 1em",
                    width: WEBPAGE_CORE_CONTAINER,
                    maxWidth: "100%",
                    "&::before": {
                        content: '""',
                        flexBasis: { xs: "72%", md: "60%" },
                    },
                }}
            >
                <Typography
                    variant="h1"
                    sx={{
                        color: "var(--mui-palette-lightest)",
                        lineHeight: 1,
                    }}
                >
                    {t("services.banner.title")}
                </Typography>

            </Stack>

        </Box>
    );
};

export default ServicesBanner;
